import { useEffect, useState } from "react"
import { Route, Switch, useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom'
import { useStore } from "react-redux"

import Header from "../../components/CommonComponents/Header"
import CommonContainer from "../../components/CommonContainer"
import DomainComponent from "../../components/DomainComponent"
import PartnerManageComponent from "../../components/PartnerManageComponent"
import ThresholdSettings from "../../components/ThresholdSettingComponent"
import CallerSettings from "../../components/CallerSettingsComponent"
import AppEmail from "../../components/UserSettings/app"
import { CONSTANTS } from "../../utils/constants/constants"

const Settings = () => {
    const store = useStore().getState()
    const history = useHistory()
    const location = useLocation()

    const {
        domain: { myDomains, domainRequestors, isLoading },
        auth: { user }
    } = store

    const [settingsSelected, setSettingsSelected] = useState(user?.roleName === CONSTANTS.ROLE_NAME.ADMIN ? 'Access' : 'In App')
    const [currentTab, setCurrentTab] = useState('domains')

    const sideBarOptions = [
        { name: 'Access', to: 'access' },
        { name: 'In App', to: 'in-app' }
    ]

    const inAppTabs = [
        { name: 'Matching', to: 'matching' },
        { name: 'Calling', to: 'calling' },
        { name: 'Emailing', to: 'emailing' }
    ]

    const accesstabs = [
        { name: 'Domains', to: 'domains' },
        { name: 'Partners', to: 'partners' },
        { name: 'Users', to: 'users' }
    ]

    const selectSettingHandler = (settings) => {
        setSettingsSelected(settings)
        if (settings === 'Access') {
            history.push(`/settings/access/domains`)
        } else {
            setCurrentTab('matching')
            history.push(`/settings/app/matching`)
        }
    }

    const onNavigate = (path) => {
        setCurrentTab(path)
        if (settingsSelected === "Access") {
            history.push(`/settings/access/${path}`)
        } else {
            history.push(`/settings/app/${path}`)
        }
    }

    useEffect(() => {
        if (location?.pathname === CONSTANTS.ROUTES.DOMAIN) {
            setSettingsSelected(sideBarOptions[0].name)
            setCurrentTab('domains')
        } else if (location?.pathname === CONSTANTS.ROUTES.PARTNERS) {
            setSettingsSelected(sideBarOptions[0].name)
            setCurrentTab('partners')
        } else if (location?.pathname === CONSTANTS.ROUTES.USERS) {
            setSettingsSelected(sideBarOptions[0].name)
            setCurrentTab('users')
        } else if (location?.pathname === CONSTANTS.ROUTES.MATCHING) {
            setSettingsSelected(sideBarOptions[1].name)
            setCurrentTab('matching')
        } else if (location?.pathname === CONSTANTS.ROUTES.CALLING) {
            setSettingsSelected(sideBarOptions[1].name)
            setCurrentTab('calling')
        } else if (location?.pathname === CONSTANTS.ROUTES.EMAILING) {
            setSettingsSelected(sideBarOptions[1].name)
            setCurrentTab('emailing')
        } else if (location?.pathname === "/settings") {
            if (user?.roleName === CONSTANTS.ROLE_NAME.ADMIN && user?.roleId === CONSTANTS.ROLE_ID.ADMIN) {
                history.push(CONSTANTS.ROUTES.DOMAIN)
            } else if (user?.roleName === CONSTANTS.ROLE_NAME.MODERATOR && user?.roleId === CONSTANTS.ROLE_ID.MODERATOR && user?.isCaller) {
                history.push(CONSTANTS.ROUTES.CALLING)
            } else if (user?.roleName === CONSTANTS.ROLE_NAME.MODERATOR && user?.roleId === CONSTANTS.ROLE_ID.MODERATOR && !user?.isCaller) {
                history.push(CONSTANTS.ROUTES.EMAILING)
            } else if (user?.roleName === CONSTANTS.ROLE_NAME.USER && user?.roleId === CONSTANTS.ROLE_ID.USER && !user?.isCaller) {
                history.push(CONSTANTS.ROUTES.EMAILING)
            } else if (user?.roleName === CONSTANTS.ROLE_NAME.USER && user?.roleId === CONSTANTS.ROLE_ID.USER && user?.isCaller) {
                history.push(CONSTANTS.ROUTES.CALLING)
            }
        } else {
            if (location?.pathname.includes('access') && user?.roleName === CONSTANTS.ROLE_NAME.ADMIN && user?.roleId === CONSTANTS.ROLE_ID.ADMIN) {
                setSettingsSelected(sideBarOptions[0].name)
                location?.pathname?.includes('domains') ? setCurrentTab('domains') : location?.pathname?.includes('partners') ? setCurrentTab('partners') : setCurrentTab('users')
            } else if (location?.pathname.includes('app') && user?.roleName === CONSTANTS.ROLE_NAME.USER && user?.roleId === CONSTANTS.ROLE_ID.USER) {
                setSettingsSelected(sideBarOptions[1].name)
                location?.pathname?.includes('matching') ? setCurrentTab('matching') : location?.pathname?.includes('calling') ? setCurrentTab('calling') : setCurrentTab('emailing')
            }
        }
    }, [location?.pathname])

    let tabs = []
    if (settingsSelected === "Access") {
        tabs = [...accesstabs]
    } else {
        tabs = [...inAppTabs]
    }

    return (
        <CommonContainer>
            <Header header={`Settings`} />
            <div className=" row mt-4  w-100   " style={{ height: '90%' }}>
                <div className="col-2 p-3 h-100" style={{ backgroundColor: "#F6F8FC" }}>
                    {user?.roleName === 'admin' && user?.roleId === 3 && <div
                        key='Access'
                        className="text-center settings"
                        style={{
                            cursor: 'pointer',
                            borderRadius: 5,
                            backgroundColor: `${settingsSelected === 'Access' ? '#DEEBFF' : ''}`,
                        }}
                        onClick={() => { selectSettingHandler('Access') }}
                    >
                        <p className="fs-4 fw-bold p-2" style={{ color: '#214466' }}>Access</p>
                    </div>}
                    <div
                        key='In App'
                        className="text-center settings"
                        style={{
                            cursor: 'pointer',
                            borderRadius: 5,
                            backgroundColor: `${settingsSelected === 'In App' ? '#DEEBFF' : ''}`,
                        }}
                        onClick={() => { selectSettingHandler('In App') }}
                    >
                        <p className="fs-4 fw-bold p-2" style={{ color: '#214466' }}>In App</p>
                    </div>
                </div>
                <div className="col-10  h-100 ">
                    <div className="d-flex ms-5 align-items-center   ">
                        {settingsSelected === "Access" &&
                            <ul className="nav fs-4 fw-bold underline-gap d-flex align-items-center">
                                {tabs.map((tab) => {
                                    return (
                                        <p
                                            className={`text-black ${tab?.name === "Domains" ? 'm-3 ms-0' : 'm-3'}  fs-4 fw-bold underline-gap ${currentTab === tab?.to ? 'settingsActiveTab' : ''} `}
                                            key={tab?.name}
                                            onClick={() => { onNavigate(tab?.to) }} style={{ cursor: 'pointer' }}>
                                            {tab?.name}
                                        </p>
                                    )
                                })}
                            </ul>
                        }
                        {
                            settingsSelected !== "Access" && (
                                <ul className="nav fs-4 fw-bold underline-gap d-flex align-items-center">
                                    {user?.roleName === CONSTANTS.ROLE_NAME.ADMIN && user?.roleId === CONSTANTS.ROLE_ID.ADMIN && <p
                                        className={`text-black m-3  fs-4 fw-bold underline-gap ${currentTab === 'matching' ? 'settingsActiveTab' : ''} `}
                                        onClick={() => { onNavigate('matching') }} style={{ cursor: 'pointer' }}>
                                        Matching
                                    </p>}
                                    {((user?.isCaller) || (user?.roleName === CONSTANTS.ROLE_NAME.ADMIN && user?.roleId === CONSTANTS.ROLE_ID.ADMIN)) && <p
                                        className={`text-black m-3 fs-4 fw-bold underline-gap ${currentTab === 'calling' ? 'settingsActiveTab' : ''} `}
                                        onClick={() => { onNavigate('calling') }} style={{ cursor: 'pointer' }}>
                                        Calling
                                    </p>}
                                    <p
                                        className={`text-black m-3  fs-4 fw-bold underline-gap ${currentTab === 'emailing' ? 'settingsActiveTab' : ''} `}
                                        onClick={() => { onNavigate('emailing') }} style={{ cursor: 'pointer' }}>
                                        Emailing
                                    </p>
                                </ul>
                            )
                        }

                    </div>
                    <div className="mt-4  overflow-y-scroll no-scrollbar" style={{ height: '90%' }}>
                        <div className="h-100">
                            <Switch>
                                {user?.roleName === CONSTANTS.ROLE_NAME.ADMIN && user?.roleId === CONSTANTS.ROLE_ID.ADMIN && <Route
                                    path={CONSTANTS.ROUTES.DOMAIN}
                                    component={DomainComponent}
                                />}
                                {user?.roleName === CONSTANTS.ROLE_NAME.ADMIN && user?.roleId === CONSTANTS.ROLE_ID.ADMIN && <Route
                                    path={CONSTANTS.ROUTES.PARTNERS}
                                    component={PartnerManageComponent}
                                />}
                                {user?.roleName === CONSTANTS.ROLE_NAME.ADMIN && user?.roleId === CONSTANTS.ROLE_ID.ADMIN && <Route
                                    path={CONSTANTS.ROUTES.USERS}
                                    component={DomainComponent}
                                />}

                                {user?.roleName === CONSTANTS.ROLE_NAME.ADMIN && user?.roleId === CONSTANTS.ROLE_ID.ADMIN && <Route
                                    path={CONSTANTS.ROUTES.MATCHING}
                                    component={ThresholdSettings}
                                />}

                                <Route
                                    path={CONSTANTS.ROUTES.CALLING}
                                    component={CallerSettings}
                                />
                                <Route
                                    path={CONSTANTS.ROUTES.EMAILING}
                                    component={AppEmail}
                                />
                            </Switch>
                        </div>


                    </div>
                </div>
            </div>
        </CommonContainer>
    )
}

export default Settings